import styled from 'styled-components'

import { type MessageSender } from '../Message'

export const MessageRowStyled = styled.div<{ $sender: MessageSender }>`
  display: flex;
  width: 100%;
  justify-content: ${(props) =>
    props.$sender === 'user' ? 'flex-end' : 'flex-start'};
`
